import { boundsKeyAxis } from '../../bounds.js';
import { margin, size } from '../../types.js';
import { KeyScale } from './KeyScale.js';
import { KeyValueSet } from './KeyValueSet.js';
export const getKeyScale = (svgSize: size, svgMargin: margin, keyValueSet: KeyValueSet) => new KeyScale(boundsKeyAxis(svgSize, svgMargin), keyValueSet);